import {
  faCheckDouble,
  faSquareCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AssignmentExtendedModel } from 'api/model';
import AuthorizedButton from 'components/inputs/AuthorizedButton';
import Button from 'components/inputs/Button';
import Roles from 'constants/Roles';
import React, { FC } from 'react';
import styled from 'styled-components';
import useAutoapproveAssignmentsBulkOperations from './useAutoapproveAssignmentsBulkOperations';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Left = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin: 10px;
  gap: 20px;
`;
const Right = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin: 10px;
  gap: 20px;
`;

interface Props {
  bulkActions: React.ReactNode[];
  bulkOperations: ReturnType<typeof useAutoapproveAssignmentsBulkOperations>;
  handleAssignmentItemClick?(model: AssignmentExtendedModel): void;
}

const AutoApproveBulkOperations: FC<Props> = ({
  bulkActions,
  bulkOperations,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleAssignmentItemClick,
}) => {
  return (
    <Wrapper>
      <Left>
        <Button
          icon={<FontAwesomeIcon icon={faSquareCheck} />}
          onClick={() => bulkOperations.selectAllApprovableAssignments()}
        >
          Välj alla {bulkOperations.autoApprovableSelectableAssignments.length}{' '}
          direkt godkännbara
        </Button>
        {/* Väljer ALLA valbara uppdrag på sidan oavsett autogodkännbarhetsstatus —
            samma roller som får bulk-godkänna (AutoApproveBulkApproval), speglas av
            [Authorize] på ApproveMultipleAssignmentsWithAutoApprovalConditions. */}
        <AuthorizedButton
          icon={<FontAwesomeIcon icon={faCheckDouble} />}
          roles={[Roles.Ekonomi, Roles.SuperAdmin, Roles.Efterkontroll]}
          onClick={() => bulkOperations.selectAllAssignments()}
          title="Väljer även uppdrag som inte är direkt godkännbara (har avvikelser eller är ej kontrollerade)"
        >
          Välj alla {bulkOperations.selectableAssignments.length} på sidan
        </AuthorizedButton>
        {bulkOperations.selectedAssignmentIds.size > 0 && (
          <Button onClick={() => bulkOperations.clearSelectedAssignments()}>
            Rensa val
          </Button>
        )}
      </Left>

      <Right>
        {bulkActions.map((action, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`action-${index}`}>{action}</div>
        ))}
      </Right>
    </Wrapper>
  );
};

export default AutoApproveBulkOperations;
